module.exports = __webpack_public_path__ + "img/cases-part1-11.2e6730ce.png";